/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Přehled',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
        role: 'user',
    },
    {
        id: 'users',
        title: 'Správa uživatelů',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
        role: 'other',
    },
    {
        id: 'partners-group',
        title: 'Partneři',
        subtitle: 'Nabídka partnerů',
        type: 'group',
        children: [
            {
                id: 'partners',
                title: 'Správa partnerů',
                type: 'basic',
                icon: 'heroicons_outline:briefcase',
                link: '/partners',
                role: 'partner',
            },
            {
                id: 'services',
                title: 'Správa služeb',
                type: 'basic',
                icon: 'heroicons_outline:bookmark-alt',
                link: '/services',
                role: 'service',
            },
            {
                id: 'cities',
                title: 'Města',
                type: 'basic',
                icon: 'heroicons_outline:office-building',
                link: '/cities',
                role: 'city',
            },
            {
                id: 'organizators',
                title: 'Organizátoři',
                type: 'basic',
                icon: 'heroicons_outline:ticket',
                link: '/organizators',
                role: 'organizators',
            },
            {
                id: 'sponsors',
                title: 'Sponzoři',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/sponsors',
                role: 'sponsors',
            },
        ],
    },
    {
        id: 'places-group',
        title: 'Místa',
        subtitle: 'Správa míst',
        type: 'group',
        role: 'city',
        children: [
            {
                id: 'places',
                title: 'Místa',
                type: 'basic',
                icon: 'heroicons_outline:location-marker',
                link: '/places',
                role: 'city',
            },
            {
                id: 'place-categories',
                title: 'Kategorie míst',
                type: 'basic',
                icon: 'heroicons_outline:view-grid',
                link: '/places-categories',
                role: 'admin',
            },
            {
                id: 'place-criteria',
                title: 'Kritéria míst',
                type: 'basic',
                icon: 'heroicons_outline:view-grid',
                link: '/places-criteria',
                role: 'admin',
            },
        ],
    },
    {
        id: 'places-group',
        title: 'Výčty',
        subtitle: 'Správa číselníků',
        type: 'group',
        role: 'other',
        children: [
            {
                id: 'municipality-levels',
                title: 'Typy oblastí',
                type: 'basic',
                icon: 'heroicons_outline:globe',
                link: '/municipality-levels',
            },
            {
                id: 'extra-services',
                title: 'Extra služby',
                type: 'basic',
                icon: 'heroicons_outline:lock-open',
                link: '/extra-services',
            },
            {
                id: 'employments',
                title: 'Pracovní zařazení',
                type: 'basic',
                icon: 'heroicons_outline:bookmark',
                link: '/employments',
            },
            // {
            //     id   : 'shipping-types',
            //     title: 'Typy dopravy',
            //     type : 'basic',
            //     icon : 'heroicons_outline:truck',
            //     link : '/shipping-types'
            // },
            {
                id: 'place-activities',
                title: 'Správa aktivit',
                type: 'basic',
                icon: 'heroicons_outline:color-swatch',
                link: '/place-activities',
            },
        ],
    },
    {
        id: 'misc-group',
        title: 'Ostatní',
        type: 'group',
        children: [
            {
                id: 'rating-approve',
                title: 'Hodnocení',
                type: 'basic',
                icon: 'heroicons_outline:star',
                link: '/rating-approve',
                role: 'other',
            },
            {
                id: 'balance',
                title: 'Transakce',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/balance',
                role: 'user',
            },
            {
                id: 'reservations-overview',
                title: 'Přehled rezervací',
                type: 'basic',
                icon: 'heroicons_outline:calendar',
                link: '/reservations-overview',
                role: 'other',
            },
            {
                id: 'notifications',
                title: 'Notifikace',
                type: 'basic',
                icon: 'heroicons_outline:bell',
                link: '/notifications',
                role: 'other',
            },
            {
                id: 'global-settings',
                title: 'Globální nastavení',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: '/global-settings',
                role: 'other',
            },
        ],
    },
    {
        id: 'app-group',
        title: 'Aplikace Lovlio',
        subtitle: 'Vše co potřebujete vědět o Lovlio',
        type: 'group',
        children: [
            {
                id: 'support',
                title: 'Podpora',
                type: 'basic',
                icon: 'heroicons_outline:question-mark-circle',
                link: '/support',
            },
            {
                id: 'changelog',
                title: 'Changelog',
                type: 'basic',
                icon: 'heroicons_outline:newspaper',
                link: '/changelog',
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
